import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';

import { Link, useNavigate } from 'react-router-dom';
import { getAdmitCard, getPaymentInfo } from "../AdmitCard/api"
import { updateWizardStatus } from '../../store/auth/actions'
import BackButton from '../../components/backButton'

const Wizard = (props) => {

    const [payment, setPayment] = useState(false)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        let payment = await getPaymentInfo()

        if (payment.data) {
            setPayment(payment.data)
        }
        let res = await getAdmitCard()
        if (res.code) {
            console.log(res.data.user_det);
            let wizard = {
                application: res.data.user_det?.passport ? "filled" : "new",
                document: res.data.user_det?.document ? "filled" : "new",
                updateCenter: res.data.user_det?.is_approved == 1 ? "new" : "disabled",
            }
            props.updateWizardStatus(wizard)
        }


    }

    return (
        <>
            <BackButton to={props.redirect} light />
            {/* Was two "Step 1"/"Step 2" buttons whose only state was an
                inline backgroundColor:green — no indication of what each step
                was, which one you were on, or what "green" meant. A real step
                bar: numbered, named, with a done/current state. */}
            <ol className='ui_steps'>
                <li className={`ui_step ${props.auth.wizardStatus?.application === 'filled' ? 'is_done' : ''}`}>
                    <Link to='/application-form'>
                        <span className='ui_step_no'>
                            {props.auth.wizardStatus?.application === 'filled'
                                ? <i className='fa fa-check' aria-hidden='true'></i>
                                : 1}
                        </span>
                        <span className='ui_step_text'>
                            <span className='ui_step_name'>Application Form</span>
                            <span className='ui_step_state'>
                                {props.auth.wizardStatus?.application === 'filled' ? 'Completed' : 'Pending'}
                            </span>
                        </span>
                    </Link>
                </li>

                <li className={`ui_step ${props.auth.wizardStatus?.document === 'filled' ? 'is_done' : ''}`}>
                    <Link to='/step2'>
                        <span className='ui_step_no'>
                            {props.auth.wizardStatus?.document === 'filled'
                                ? <i className='fa fa-check' aria-hidden='true'></i>
                                : 2}
                        </span>
                        <span className='ui_step_text'>
                            <span className='ui_step_name'>Upload Documents</span>
                            <span className='ui_step_state'>
                                {props.auth.wizardStatus?.document === 'filled' ? 'Completed' : 'Pending'}
                            </span>
                        </span>
                    </Link>
                </li>

                {/* CCTE: slot booking and payment, shown once the payment
                    check says the candidate may book. */}
                {payment
                    ? <li className='ui_step'>
                        <Link to='/step3'>
                            <span className='ui_step_no'>3</span>
                            <span className='ui_step_text'>
                                <span className='ui_step_name'>Book Slot &amp; Pay</span>
                                <span className='ui_step_state'>Available</span>
                            </span>
                        </Link>
                    </li>
                    : null}
            </ol>
            <div className="card-header">
                <div className='card-header-container'>
                    <div></div>
                    <div>
                        <i className='fa fa-laptop'></i>{props.title}
                    </div>
                    <div>
                        {/* <button data-bs-toggle="modal" data-bs-target="#helpModal" type="button" className="btn btn-warning btn-sm"><i className='fa fa-question'></i>&nbsp;Help</button> */}
                    </div>
                </div>
            </div>

            {/* modal */}
            <div className="modal fade" id="helpModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Help</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            In case of Any Application related query, Please contact your Pariksha Mitra.<br /><br />


                            Shivam Kumar, Pariksha Mitra - 9113123269<br />

                            Shakti kumar, Pariksha Mitra - 808349066<br />

                            Mayank Kumar, Pariksha Mitra - 8252373042<br />

                            Md. Khalid, Pariksha Mitra - 9795575905<br />
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.Auth
    }
}

const mapDispatchToProps = { updateWizardStatus }
export default connect(mapStateToProps, mapDispatchToProps)(Wizard);